import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { StaticQuery, graphql } from "gatsby";

function SEO({ description, lang, meta, keywords, title, image, url }) {
  return (
    <StaticQuery
      query={detailsQuery}
      render={data => {
        const page = data.wordpressPage.acf;
        const baseUrl = "http://kzwickerphotography.netlify.com";
        const path = url ? url : "";
        return (
          <Helmet
            htmlAttributes={{
              lang
            }}
            title={title}
            titleTemplate={`%s | ${data.wordpressSiteMetadata.name}`}
            meta={[
              {
                name: `description`,
                content: description || data.wordpressSiteMetadata.description
              },
              {
                name: `og:site_name`,
                content: data.wordpressSiteMetadata.name
              },
              {
                property: `og:title`,
                content:
                  title === "Home" ? data.wordpressSiteMetadata.name : title
              },
              {
                property: `og:description`,
                content: description || data.wordpressSiteMetadata.description
              },
              {
                property: `og:image`,
                content: image
                  ? baseUrl + image
                  : page.carousel[0].image.localFile.childImageSharp
                    .sizes.src
              },
              {
                property: `og:url`,
                content: baseUrl + path
              },
              {
                property: `og:type`,
                content: `website`
              },
              {
                name: `twitter:card`,
                content: `summary_large_image`
              },
              {
                name: `twitter:creator`,
                content: data.site.siteMetadata.author
              },
              {
                name: `twitter:title`,
                content:
                  title === "Home" ? data.wordpressSiteMetadata.name : title
              },
              {
                name: `twitter:description`,
                content: description || data.wordpressSiteMetadata.description
              },
              {
                name: `twitter:image`,
                content: image
                  ? baseUrl + image
                  : page.carousel[0].image.localFile.childImageSharp
                    .sizes.src
              }
            ]
              .concat(
                keywords.length > 0
                  ? {
                    name: `keywords`,
                    content: keywords.join(`, `)
                  }
                  : []
              )
              .concat(meta)}
          />
        );
      }}
    />
  );
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  keywords: []
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.array,
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired
};

export default SEO;

const detailsQuery = graphql`
  query DefaultSEOQuery {
    wordpressSiteMetadata {
      name
      description
    }
    wordpressPage(title: { eq: "Home" }) {
      acf {
        carousel {
          image {
            localFile {
              childImageSharp {
                sizes(maxWidth: 1920) {
                  ...GatsbyImageSharpSizes
                }
              }
            }
          }
        }
      }
    }
    site {
      siteMetadata {
        title
        description
        author
      }
    }
  }
`;
